<template>
    <div class="row">
        <div class="form-group col-md-2" v-for="col in tableColumns" v-bind:key="col.key">
            <label class="control-label"><span v-if="col.form.required === true" class="lbl-obg">*</span>{{ $t(col.label) }}:</label>
            <mmf-form-helper is-editing
                            :name="col.key"
                            :metadata="col" 
                            :value="getKeyValue(col)" 
                            @input="changeEntityAttribute(col, $event)"
                            @bind="changeEntityAttribute(col, $event)" />
            <span v-show="errors.has(col.key)" class="lbl-obg">
                {{ errors.first(col.key) }}
            </span>
        </div>
    </div>
</template>


<script>
import MmfFormHelper from "@/components/MmfFormHelper";
import model from '@/model/index'
// import { mapActions } from "vuex";

export default {
    name: 'mmf-entity-form',
    data() {
        return {
        }
    },
    components: { MmfFormHelper },
    props: {
        'entity': String,
    },
    computed: {
        tableColumns() {
            return model[this.entity].entityFormConfigs;
        },
        entityObject: {
            get() {
                var result = this.$store.state[this.entity].entity
                return result
            }
        }
    },
    methods: {
        changeEntityAttribute(col, $event) {
            var splited = col.key.split(".")
            var key = col.key
            var newValue = $event
            if (splited.length > 1) {
                var baseAttribute = this.entityObject[splited[0]]

                baseAttribute = baseAttribute !== "" ? Object.assign({}, baseAttribute) : {}

                var newAttribute = baseAttribute
                for (var i=1; i < splited.length; i++) {
                    var iKey = splited[i]
                    newAttribute[iKey] = i === splited.length - 1 ? $event : {}
                    newAttribute = newAttribute[iKey]
                }

                key = splited[0]
                newValue = baseAttribute
            }
            
            this.$store.commit(this.entity + "/setEntityAttribute", {key: key, newValue: newValue})
            if (col.form.type === 'entitySelect'){
                var id = $event ? $event : 0
                if (col.form.onChangeDispatchAction) {
                    for (var i in col.form.onChangeDispatchAction){
                        this.$store.dispatch(col.form.onChangeDispatchAction[i], { id, mainEntity: this.entity, type: 'entity' })
                    }
                }
            }
        },
        getKeyValue(col){
            if (this.entityObject.hasOwnProperty(col.key)) {
                return this.entityObject[col.key]
            }
            else {
                var localObject = this.entityObject
                var splited = col.key.split('.')
                for (var i=0; i < splited.length; i++){
                    if (localObject[splited[i]] === "") {
                        return localObject[splited[i]]
                    }
                    localObject = localObject[splited[i]]
                }

                return localObject
            }

        }
    }
}
</script>
